module.exports = __webpack_public_path__ + "img/10-sdg-full@2x.17a64f3b.png";